module.exports = "pegasus/assets/tech/safari/100.png";